import {MemberInfoForCompletePage} from '../Props/MemberRegisterPageLocationStates'
import {Signboard, SignboardDTO, SignboardJSON} from './SignboardDTO'
import {ContractInfoWithContractDate} from '../Props/ContractInputInfo'
import {BucketMemberId} from './BucketMemberId'
import {fromJsonBucketMemberIdList} from './BucketRegisterResponseDataDTO'

export type MemberRegisterResultJSON =
  Pick<MemberRegisterResult, 'bucketMemberIdList' | 'memberInfo' | 'contractInfo'>
  & {
  signboard: SignboardJSON
}

export interface MemberRegisterResult {
  bucketMemberIdList: BucketMemberId[]
  memberInfo: MemberInfoForCompletePage
  signboard: Signboard
  contractInfo: ContractInfoWithContractDate
}

export class MemberRegisterResultDTO implements MemberRegisterResult {
  bucketMemberIdList: BucketMemberId[]
  memberInfo: MemberInfoForCompletePage
  contractInfo: ContractInfoWithContractDate
  signboard: Signboard

  constructor(
    bucketMemberIdList: BucketMemberId[],
    memberInfo: MemberInfoForCompletePage,
    contractInfo: ContractInfoWithContractDate,
    signboard: Signboard,
  ) {
    this.bucketMemberIdList = bucketMemberIdList
    this.contractInfo = contractInfo
    this.memberInfo = memberInfo
    this.signboard = signboard
  }

  static fromJSON(jsonObject: MemberRegisterResultJSON): MemberRegisterResultDTO {
    return new MemberRegisterResultDTO(
      fromJsonBucketMemberIdList(jsonObject.bucketMemberIdList),
      jsonObject.memberInfo,
      jsonObject.contractInfo,
      {...SignboardDTO.fromJSON(jsonObject.signboard)},
    )
  }
}
